import React from "react";
import { Link } from "react-router-dom";
import FooterOne from "../Footer/FooterOne";
import Header from "../Header/HeaderTwo";
import { pageTitle } from "../PageTitle";
import Form from "./Form";
import { isMobile } from "mobile-device-detect";

const Contact = () => {
  pageTitle("Contact Us");
  return (
    <>
      <Header></Header>
      <div
        className="contact__area section-padding"
        style={{ paddingTop: "250px" }}
      >
        <div className="container">
          <div className="row mb-60">
            <div className="col-xl-5 col-lg-6">
              <div className="contact__area-title">
                <span className="subtitle">Contact Us</span>
                <h2>Need Yor any help Contact with Us</h2>
              </div>
              <div className="contact__area-info">
                <div className="contact__area-info-item">
                  <div className="contact__area-info-item-icon">
                    <i className="far fa-phone-alt"></i>
                    <span>Phone :</span>
                  </div>
                  <div className="contact__area-info-item-content">
                    <a href="tel:01110062168">01110062168</a>{" "}
                    {/* <a href="tel:01559292398">01559292398</a> */}
                  </div>
                </div>
                <div className="contact__area-info-item">
                  <div className="contact__area-info-item-icon">
                    <i className="fal fa-envelope"></i>
                    <span>Email :</span>
                  </div>
                  <div className="contact__area-info-item-content">
                    <a href="mailto:elbrokerapp@gmail.com">
                      Info.requestak@gmail.com
                    </a>
                  </div>
                </div>
                {/* <div className="contact__area-info-item">
                  <div className="contact__area-info-item-icon">
                    <i className="far fa-map-marker-alt"></i>
                    <span>Location:</span>
                  </div>
                  <div className="contact__area-info-item-content">
                    <a
                      href="https://maps.app.goo.gl/z3zE8KGQu53SynbS7"
                      target="_blank"
                    >
                      13 Ahmed Fouad Street, in front of Al Tayaran Sporting
                      Club, El Nozha, Heliopolis, Cairo
                    </a>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
          {/* <div className="row">
            <div className="col-xl-12">
              <div className="contact__area-bottom">
                <div className="contact__area-bottom-form page">
                  <Form></Form>
                </div>
                <div className="contact__area-bottom-map">
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3451.589425587681!2d31.3455904!3d30.105942900000002!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14583f71828fb8bf%3A0xde71d8dac7cabdc1!2sNeon%20Digital%20Agency!5e0!3m2!1sen!2seg!4v1704961529848!5m2!1sen!2seg"
                    loading="lazy"
                  ></iframe>
                </div>
              </div>
            </div>
          </div> */}
        </div>
      </div>
      <FooterOne></FooterOne>
    </>
  );
};

export default Contact;
